// src/testimonial/Testimonial.js
import './Testimonial.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import TestimoniCard from '../../components/TestimoniCard/TestimoniCard';
import Slider from 'react-slick';
import TexturePattern from '../../components/TexturePattern/TexturePattern';
import testimonialData from './TestimonialData';


const Testimonial = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 767, settings: { slidesToShow: 2, initialSlide: 2 } },
      { breakpoint: 575, settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  };

  return (
    <section className='service-section pt-100 pb-70 position-relative' data-aos="fade-up" data-aos-duration="2000">
      <TexturePattern isFooter={false} />
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-sm-6">
            <SectionTitle subTitle="TESTIMONIAL" title="What people have said about us" />
          </div>
          <div className="col-lg-6 col-sm-6">
            <p className='service-title-text'>
              Read what our clients have to say about our services.
            </p>
          </div>
        </div>
        <Slider {...settings} className="testimoni-slider">
          {testimonialData.map((r, i) => (
            <TestimoniCard
              key={i}
              img={r.img}
              name={r.name}
              description={r.content}
              rating={5}
              profile={r.profile}
            />
          ))}
        </Slider>
        <div className="theme-btn review-btn" style={{display: 'inline-block', marginTop: '32px'}}>
          <a href="https://www.google.com/search?sca_esv=a56679814246b468&rlz=1C1GCEU_enZA923ZA923&sxsrf=AE3TifMS9Fjn-AhqcmcYTGNjiFUyfhkNlA:1750883730935&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-ExYl9rvxnlt7NdxU1lbF7HDBDmnpCf9vEGuJgEPSHg0emLaLN3_Zb9V4hMnYOsoqWH6vnvKV39sE8H0QIkhf0to1BezVMxAgK7pd9gV7XKn22ZOJ3w%3D%3D&q=Dr+Mishqah+Dollie+Reviews&sa=X&ved=2ahUKEwiQ6syWto2OAxWpXKQEHdcWMaQQ0bkNegQIJRAE&biw=1536&bih=695&dpr=1.25" target="_blank" rel="noopener noreferrer">Leave a Review</a>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
